module.exports = __webpack_public_path__ + "components/homepage-hero/static/icon-search-9c2d261e74724af20d5a5cd48e1f6219.svg";